import axios from 'axios';

import { SERVICEBASEURL } from 'enums/serviceBaseUrls';
import { Optional } from 'functions/promiseExtensions';

export function callApi(
	searchTerm: string,
	showOnlyDeleted: boolean
): Promise<Optional<ResponseNutriScoreLabel[]>> {
	const url: string = `${SERVICEBASEURL.BACKEND}/NutriScoreLabel/StartingWith`;
	const params: Parameter = {
		SearchTerm: searchTerm,
		ShowOnlyDeleted: showOnlyDeleted,
	};
	return axios
		.get(url, {
			params: params,
		})
		.toOptionalMapped((x) => x.data.nutriScoreLabels);
}

interface Parameter {
	SearchTerm: string;
	ShowOnlyDeleted: boolean;
}

export interface Response {
	data: ResponseData;
}

export type ResponseData = {
	nutriScoreLabels: ResponseNutriScoreLabel[];
};

export type ResponseNutriScoreLabel = {
	id: string;
	isFluid: boolean;
	label: string;
	color: string;
};
